// A rank as the screens say it (B-251, B-321): "WR9" on the row, and in
// words on a hover. One place, so Players, the slot's list and the card agree.

import { positionLabel } from '../../kit';

/** "12th", for a rank's hover. */
export function ordinalOf(n: number): string {
  const tens = n % 100;
  if (tens >= 11 && tens <= 13) return `${n}th`;
  return `${n}${['th', 'st', 'nd', 'rd'][n % 10] ?? 'th'}`;
}

/** "WR9": the position and the rank there. */
export function rankText(position: string, rank: number): string {
  return `${positionLabel(position)}${rank}`;
}

/** The season rank in words (B-321): "9th most points among WRs this season". */
export function seasonRankWords(position: string, rank: number): string {
  return `${ordinalOf(rank)} most points among ${positionLabel(position)}s this season`;
}
